import {InputGroup} from '@chakra-ui/react';

export default function ChakraInputGroup({children, ...rest}) {
    return <InputGroup {...rest}>{children}</InputGroup>;
}
